"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncJoinAsStringWith = asyncJoinAsStringWith;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

async function asyncJoinAsStringWith(strings, separator) {
  let result = '';
  let first = true;

  for await (const str of strings) {
    if (!first && separator !== '') result += separator;

    if (typeof str !== 'string' && (0, _asyncIterable.asyncIsIterable)(str)) {
      for await (const character of str) {
        result += character;
      }
    } else {
      result += str;
    }

    first = false;
  }

  return result;
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncJoinAsStringWith, {
  reduces: true
});

exports.default = _default;